// extracted by mini-css-extract-plugin
export var askAiIcon = "_ot-k";
export var category = "_ot-a";
export var categoryHeader = "_ot-f";
export var container = "_ot-0";
export var group = "_ot-b";
export var groupItems = "_ot-g";
export var groupSeparator = "_ot-l";
export var highlight = "_ot-8";
export var loading = "_ot-1";
export var noResults = "_ot-3";
export var placeholder = "_ot-2";
export var resultContent = "_ot-5";
export var resultIcon = "_ot-d";
export var resultItem = "_ot-h";
export var resultMeta = "_ot-9";
export var resultSubtitle = "_ot-7";
export var resultSuffix = "_ot-j";
export var resultTitle = "_ot-6";
export var resultsList = "_ot-4";
export var searchGroup = "_ot-e";
export var selected = "_ot-i";
export var subgroup = "_ot-c";